import { Brand, Product } from "~src/types/brand";
import { ApiTypes, api } from "../common";
import { mergeAndCleanParams } from "../common/params";

const SEARCH_PATHS: ApiTypes.API = {
  brandNames: {
    path: `api/products/shopify-products/brands/`,
    method: ApiTypes.HTTPMethod.GET,
  },
  brandMatch: {
    path: `api/brands/`,
    method: ApiTypes.HTTPMethod.GET,
  },
  productSearch: {
    path: `api/products/shopify-products/`,
    method: ApiTypes.HTTPMethod.GET,
  },
  productVariantsSearch: {
    path: `api/products/shopify-products-variants/`,
    method: ApiTypes.HTTPMethod.GET,
  },
};

export type SearchShopifyProductResponse = {
  count: number;
  next: string;
  results: Product[];
};

export const getShopifyProductSearch = async (
  selectedBrands: string,
  searchValue: string,
  page: number,
  pageSize: number,
) => {
  const endpoint = SEARCH_PATHS.productSearch;

  const params: Record<string, any> = {
    page,
    pageSize,
    search_text: searchValue,
  };

  if (selectedBrands) {
    params.brand_name = selectedBrands;
  }

  const response = await api<SearchShopifyProductResponse>({
    method: endpoint.method,
    url: endpoint.path,
    params,
  });

  return response.data;
};

export const getShopifyProductVariants = async (product_ids: string) => {
  const endpoint = SEARCH_PATHS.productVariantsSearch;
  const response = await api<SearchShopifyProductResponse>({
    method: endpoint.method,
    url: endpoint.path,
    params: { product_ids: product_ids },
  });
  return response.data;
};

export const getBrandNames = async (searchValue?: string) => {
  const endpoint = SEARCH_PATHS.brandNames;
  const response = await api<string[]>({
    method: endpoint.method,
    url: endpoint.path,
    params: {
      search_value: searchValue,
    },
  });
  return response.data;
};

export const getShopifyProductSearchBrands = async (searchValue: string) => {
  const endpoint = SEARCH_PATHS.productSearch;
  const response = await api<SearchShopifyProductResponse>({
    method: endpoint.method,
    url: endpoint.path,
    params: { brand_name: searchValue },
  });
  return response.data;
};

export interface BrandSearchParams {
  page?: number;
  page_size?: number;
  search_text?: string;
}

const defaultParams: BrandSearchParams = {
  page: 1,
  page_size: 10,
};
export type BrandSearchResponse = {
  count: number;
  next: string;
  previous: string;
  results: Brand[];
};

export const getBrandSearch = async (params: BrandSearchParams) => {
  const endpoint = SEARCH_PATHS.brandMatch;
  const queryString = mergeAndCleanParams<BrandSearchParams>(
    params,
    defaultParams,
  );
  const response = await api<BrandSearchResponse>({
    method: endpoint.method,
    url: `${endpoint.path}?${queryString}`,
  });
  return response?.data;
};
